module.exports = __webpack_public_path__ + "assets/icon-info-component.ef54785f.svg";